import styled from 'styled-components';

export const DeletDiv = styled('div')<{ success: boolean }>`
  display: flex;
  flex-direction: column;

  color: #df0a24;
  ${props => props.success && `color: #75B843 !important`}
`;

export const Content = styled.div`
  margin-top: 3%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1vh;

  svg {
    margin-bottom: 10px;
    width: 20%;
    height: auto;
  }

  b {
    font-size: 1.3rem;
    line-height: 22px;
    text-align: center;
  }

  p {
    font-size: 1rem;
    width: 100%;
    word-wrap: break-word;
    text-align: center;
  }
`;

export const TitleModal = styled.div`
  b {
    font-size: 20px;
  }
  svg {
    height: auto;
    width: 2vh;
    color: #488cfa;
  }
  display: flex;
  justify-content: right;
  margin-bottom: -2vh;
`;
